'use client';

import { SignupContainer } from '@/features/onboarding/containers/SignupContainer';

export default function SignupPage() {
  return (
    <div data-testid="onboarding-signup-page">
      <SignupContainer />
    </div>
  );
}
